<template>
    <div class="aside">
        <router-link tag="div" to="/viewer">地形切割</router-link>
        <router-link tag="div" to="/demo1">倾斜摄影矩阵变换</router-link>
        <router-link tag="div" to="/translation">实体矩阵变换</router-link>
        <router-link tag="div" to="/globeTransparent">地表透明</router-link>
        <router-link tag="div" to="/videoEnty">视频实体</router-link>
        <router-link tag="div" to="/weather">天气效果</router-link>
        <router-link tag="div" to="/czml">czml</router-link>
        <router-link tag="div" to="/czmlEnty">czmlEnty</router-link>
        <router-link tag="div" to="/entysTransform">多个模型运动</router-link>
        <router-link tag="div" to="/layer">图层</router-link>
        <router-link tag="div" to="/water">水面效果</router-link>
        <router-link tag="div" to="/citybim">城市模型</router-link>
        <router-link tag="div" to="/monomer">单体化</router-link>
        <router-link tag="div" to="/canvas">画布</router-link>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.aside{
    width: 20vw;
    height: 100vh;
    background: #f4f4f4;
}
</style>